import { PspContext } from "@/config/contexts";
import {
  faCalendarClock,
  faCirclePlus,
  faFile,
  faFileArrowDown,
  faFileArrowUp,
  faGear,
  faHouse,
  faMessage,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCalendarClock as faCalendarClockFilled,
  faCirclePlus as faCirclePlusFilled,
  faFile as faFileFilled,
  faFileArrowDown as faFileArrowDownFilled,
  faFileArrowUp as faFileArrowUpFilled,
  faGear as faGearFilled,
  faHouse as faHouseFilled,
  faMessage as faMessageFilled,
} from "@fortawesome/pro-solid-svg-icons";
import { useContext } from "react";
import { useLocation } from "react-router-dom";

export function useNavbarDesktop() {
  const { lang, user, selectedMandate } = useContext(PspContext);
  const location = useLocation();

  const relevantRight = user?.mandateRights.find(
    (mandateRight) => mandateRight.mandate.id === selectedMandate?.id,
  )?.right;

  const hasPspDocumentsTab =
    relevantRight?.allowedTabs.includes("PSP_DOCUMENTS") ||
    user?.scopes.includes("admin") ||
    user?.scopes.includes("employee") ||
    user?.scopes.includes("super_employee");

  const hasSubmittedDocumentsTab =
    relevantRight?.allowedTabs.includes("SUBMITTED_DOCUMENTS") ||
    user?.scopes.includes("admin") ||
    user?.scopes.includes("employee") ||
    user?.scopes.includes("super_employee");

  const hasUploadElement =
    relevantRight?.allowedTabs.includes("UPLOAD") ||
    user?.scopes.includes("admin") ||
    user?.scopes.includes("employee") ||
    user?.scopes.includes("super_employee");

  const hasAttendancesElement =
    selectedMandate?.hasAttendances &&
    (relevantRight?.allowedTabs.includes("ATTENDANCES") ||
      user?.scopes.includes("admin") ||
      user?.scopes.includes("employee") ||
      user?.scopes.includes("super_employee"));

  const hasTemplatesAndInstructionsElement =
    relevantRight?.allowedTabs.includes("TEMPLATES") ||
    user?.scopes.includes("admin") ||
    user?.scopes.includes("employee") ||
    user?.scopes.includes("super_employee");

  const isInBackoffice = location.pathname.startsWith("/admin");

  return {
    hasPspDocumentsTab,
    hasSubmittedDocumentsTab,
    hasUploadElement,
    hasAttendancesElement,
    hasTemplatesAndInstructionsElement,
    lang,
    isInBackoffice,
  };
}
